import React from 'react';
import styled from 'styled-components';

function styleComponent(StyledComponent, JSS) {
    const componentStyleDecorator = (props, ref) => {
        const { children } = props;

        return <StyledComponent {...props} ref={ref}>{children}</StyledComponent>;
    };

    return styled(React.forwardRef(componentStyleDecorator))`${JSS}`;
}

export default styleComponent;
